export const REPORT_BEFORE_RUN_HINT =
  'Вы можете задать сортировку для каждого выбранного поля. Если включить опцию “Изменять перед запуском”, то при формировании отчёта пользователь сможет изменить фильтрацию этого поля.';
